import { ArrowLeft } from "lucide-react";
import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const StepBack= ({stepCreation, setStepCreation}: {stepCreation: number, setStepCreation: React.Dispatch<React.SetStateAction<number>>}) => {
  /* States / Hooks
   *******************************************************************************************/
  const navigate = useNavigate();

  /* Render
   *******************************************************************************************/
  return (
    <Button variant="dark" size="sm" onClick={() =>{
      if (stepCreation > 1) {
        setStepCreation(stepCreation - 1)
      } else {
        navigate(-1)
      }
      }}>
      <ArrowLeft size={16} /> <span className="d-none d-md-inline">Retour</span>
    </Button>
  )
};
